import { render, staticRenderFns } from "./pr-attachment.vue?vue&type=template&id=b280d520&"
import script from "./pr-attachment.vue?vue&type=script&lang=js&"
export * from "./pr-attachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports